import React from "react";

const MobViewBookingCard = () => {
  return (
    <div className="mobViewBook_card_container">
      <div className="mobVIewBook_card_md">
        {[0, 1, 2, 3, 4, 5].map((val) => (
          <div className="mobVIewbook_card" key={val}>
            <div className="book_card_time">
              <div className="book_cardTimeINfo">
                <h6>From</h6>
                <p>Dubai</p>
              </div>
              <div className="book_cardTimeINfo">
                <h6>To</h6>
                <p>Last Angleses</p>
              </div>
            </div>
            <div className="bookCardBody_">
              <div className="bookCard_othrInfo">
                <h6>Travel Date</h6>
                <p>1/12/2020</p>
              </div>
              <div className="bookCard_othrInfo">
                <h6>Status</h6>
                <p>New</p>
              </div>
              <div className="bookCard_othrInfo">
                <h6>Dist. Type</h6>
                <p>Cancelled</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MobViewBookingCard;
